import React, { useState } from 'react';

const OTPInputContainer ={
    widget: {
  display: "flex",
  justifyContent: "center",
  gap: "10px",
  padding: "20px",
  backgroundColor: "#1a3d2f",
  borderRadius: "8px"
    }
}
  


const styled ={input: {
 width: "50px",
  height: "50px",
  fontSize: "1.5rem",
  textAlign: "center",
  border: "2px solid #285a43",
  backgroundColor: "#213a2e",
  color: "#d3ffd5",
  borderRadius: "4px",
  outline:"none",
  transition: "border-color 0.3s"}
}
 


const OTPInput = ({ length, onChange }) => {
  const [otp, setOtp] = useState(Array(length).fill(''));

  const handleChange = (value, index) => {
    if (!/^[0-9]$/.test(value) && value !== '') return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    onChange(newOtp.join(''));

    if (value && index < length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  return (
    <div style={OTPInputContainer.widget}>
      {otp.map((_, index) => (
        <input style={styled.input}
          key={index}
          id={`otp-input-${index}`}
          type="text"
          maxLength="1"
          value={otp[index]}
          onChange={(e) => handleChange(e.target.value, index)}
          onFocus={(e) => e.target.select()}
        />
      ))}
    </ div>
  );
};

export default OTPInput;
